<template>
	<div class="volunteer-home-online-training">
		<div class="online-training-box">
			<ssTrainList :finish="finish_" :busy="busy_" mode="2" :value="curData_" :imgUrl="require('../../../assets/img/about/library-publications.png')" detailPath="/about/libraryPublications/"/>
		</div>
		<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
	</div>
</template>

<script>
	import ssTrainList from '@/components/ss-train-list/ss-train-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		components:{
			ssTrainList
		},
		data() {
			return {
				typeList: [{
					value: 'gbkw',
					label: '馆办刊物'
				}]
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.volunteer-home-online-training{
		.online-training-box{
			background-color: #fff;
			padding: 30px 35px;
			::v-deep .train-list{
				padding-right: 90px;
				.train-item{
					margin-right: 30px;
					.train-item__top{
						height: 329px;
					}
					.train-item__title{
						text-align: center;
					}
					&:nth-of-type(4n){
						margin-right: -90px;
					}
				}
			}
		}
	}
</style>
